import { Coat, Jean, Shirt, Skirt, Dress, Accessary } from "../image/index";

export const categories = [
  { name: "상의", image: Skirt, slug: "상의" },
  { name: "원피스", image: Dress, slug: "원피스" },
  { name: "팬츠", image: Jean, slug: "하의" },
  { name: "스커트", image: Shirt, slug: "스커트" },
  { name: "아우터", image: Coat, slug: "아우터" },
  { name: "잡화", image: Accessary, slug: "악세사리" },
];
